import React from 'react';
import { Layout, Tabs } from 'antd';
import { withTranslation } from 'react-i18next';
import { NAMESPACES } from '../../i18n';
import PropTypes from 'prop-types';
import { AccountOverviewFilter, AccountReportFilter } from '../../forms';
import { AccountSummary, AccountReport } from '../../containers';
import { getEntityById } from '../../utils/asyncHelpers';
import { connect } from 'react-redux';
import accountSchema from '../../schemas/account';
import PropTypesImmutable from 'react-immutable-proptypes';
import { translateLegalEntityTypeClassificator } from '../../utils/translateHelpers';
import { accountFields } from '../../constants/account';
import './AccountOverview.css';
import * as userSelectors from '../../reducers/userReducer';
import { accountType } from '../../constants/classificators';
import { withRouter } from 'react-router-dom';
import { legalEntityFields } from '../../constants/legalEntity';
import {
  fetchAllEecsGOsForAccount,
  fetchEecsAccountOverview,
  fetchEecsAccountTotal,
} from '../../actions/actionCreators/accountActionCreators';
import { getUserLegalEntity } from '../../reducers/userReducer';

const tabKeys = {
  ACCOUNT_OVERVIEW: 'accountOverview',
  ACCOUNT_REPORT: 'accountReport',
};

class AccountOverviewPage extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    accountEntity: PropTypesImmutable.map,
    accountId: PropTypes.string,
    userAccounts: PropTypes.array,
    fetchEecsAccountOverview: PropTypes.func.isRequired,
    legalEntity: PropTypesImmutable.map,
    hydrogenAccountEntity: PropTypesImmutable.map,
    biomethaneAccountEntity: PropTypesImmutable.map,
    fetchEecsAccountTotal: PropTypes.func.isRequired,
    fetchAllEecsGOsForAccount: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      checkedFields: [],
      shownFields: [],
      eecsCode: null,
      firstRender: true,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.state.firstRender) {
      const { legalEntity, biomethaneAccountEntity, hydrogenAccountEntity } =
        this.props;

      const eecsCode =
        biomethaneAccountEntity || hydrogenAccountEntity
          ? legalEntity?.get(legalEntityFields.EECS_CODE_PRODUCER)
          : legalEntity?.get(legalEntityFields.EECS_CODE_TRADER);
      this.setState({ eecsCode, firstRender: false });
    }
    if (prevProps.accountId?.[0] !== this.props.accountId?.[0]) {
      this.setState({ firstRender: true });
    }
  }

  changeField = (newField, checked) => {
    if (checked) {
      this.setState((state) => ({
        checkedFields: [...state.checkedFields, newField],
      }));
    } else {
      this.setState((state) => ({
        checkedFields: [
          ...state.checkedFields.filter((str) => str !== newField),
        ],
      }));
    }
  };
  resetFields = () => {
    this.setState({
      checkedFields: [],
      shownFields: [],
    });
  };
  renderFields = () => {
    this.setState((state) => ({
      shownFields: [...state.checkedFields],
    }));
  };
  fieldsIncludes = (field) => {
    return this.state.shownFields.includes(field);
  };

  render() {
    const {
      t,
      accountEntity,
      accountId,
      biomethaneAccountEntity,
      hydrogenAccountEntity,
      fetchEecsAccountOverview,
      fetchEecsAccountTotal,
      fetchAllEecsGOsForAccount,
    } = this.props;
    const { eecsCode } = this.state;

    let roleCaption = '';
    if (accountEntity) {
      roleCaption = translateLegalEntityTypeClassificator(
        accountEntity.get(accountFields.TYPE)
      );
    }
    if (biomethaneAccountEntity || hydrogenAccountEntity) {
      roleCaption = translateLegalEntityTypeClassificator(
        'MANUFACTURER_GENERAL'
      );
    }
    let manufacture = false;
    let accountIds = [];
    if (accountId) {
      accountIds.push(accountId);
    }
    if (biomethaneAccountEntity) {
      accountIds.push(biomethaneAccountEntity.get(accountFields.ID));
      manufacture = true;
    }
    if (hydrogenAccountEntity) {
      accountIds.push(hydrogenAccountEntity.get(accountFields.ID));
      manufacture = true;
    }

    if (!accountId && !biomethaneAccountEntity && !hydrogenAccountEntity) {
      return (
        <Layout className="page-AccountOverviewPage main-container">
          <h1>{t('titleAdmin')}</h1>
          <AccountReportFilter t={t} />
          <div className="page-AccountOverviewPage__table-container">
            <AccountReport t={t} />
          </div>
        </Layout>
      );
    }

    return (
      <Layout className="page-AccountOverviewPage main-container">
        <h1>{t('title', { roleCaption: roleCaption.toLowerCase() })}</h1>
        <Tabs
          type="card"
          onChange={this.handleTabChange}
          defaultActiveKey={
            this.props.location.pathname.includes('/accountReport')
              ? tabKeys.ACCOUNT_REPORT
              : tabKeys.ACCOUNT_OVERVIEW
          }
        >
          <Tabs.TabPane
            key={tabKeys.ACCOUNT_OVERVIEW}
            tab={t('accountOverviewTab')}
            className="page-AccountOverviewPage__filter-container"
          >
            <AccountOverviewFilter
              accountIds={accountIds}
              manufacture={manufacture}
              t={t}
              changeField={this.changeField}
              renderFields={this.renderFields}
              resetFields={this.resetFields}
            />
            <div className="page-AccountOverviewPage__table-container">
              <AccountSummary
                accountIds={accountIds}
                manufacture={manufacture}
                t={t}
                fieldsIncludes={this.fieldsIncludes}
                fetchEecsAccountOverview={fetchEecsAccountOverview}
                fetchEecsAccountTotal={fetchEecsAccountTotal}
                fetchAllEecsGOsForAccount={fetchAllEecsGOsForAccount}
                eecsCode={eecsCode}
              />
            </div>
          </Tabs.TabPane>
          <Tabs.TabPane
            key={tabKeys.ACCOUNT_REPORT}
            tab={t('accountReportTab')}
          >
            <AccountReportFilter accountIds={accountIds} t={t} />
            <div className="page-AccountOverviewPage__table-container">
              <AccountReport accountIds={accountIds} t={t} />
            </div>
          </Tabs.TabPane>
        </Tabs>
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const userAccounts = userSelectors.getUserLegalEntityAccounts(state).toJS();
  let biomethaneProducer = false;
  let hydrogenProducer = false;
  let biomethaneProducerId = null;
  let hydrogenProducerId = null;
  let accountId = ownProps.match.params.accountId;
  if (accountId === 'manufacture') {
    accountId = null;
    userAccounts.forEach((account) => {
      if (account[accountFields.TYPE] === accountType.MANUFACTURER) {
        biomethaneProducer = true;
        biomethaneProducerId = account[accountFields.ID];
      }
      if (account[accountFields.TYPE] === accountType.HYDROGEN_MANUFACTURER) {
        hydrogenProducer = true;
        hydrogenProducerId = account[accountFields.ID];
      }
    });
  }
  return {
    accountId: accountId,
    accountEntity:
      accountId &&
      getEntityById(state, accountSchema, ownProps.match.params.accountId),
    biomethaneAccountEntity:
      biomethaneProducer &&
      getEntityById(state, accountSchema, biomethaneProducerId),
    hydrogenAccountEntity:
      hydrogenProducer &&
      getEntityById(state, accountSchema, hydrogenProducerId),
    legalEntity: getUserLegalEntity(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchEecsAccountOverview: async (eecsAccount, page) => {
    await dispatch(fetchEecsAccountOverview(eecsAccount, page));
  },
  fetchEecsAccountTotal: async (eecsAccount) => {
    await dispatch(fetchEecsAccountTotal(eecsAccount));
  },
  fetchAllEecsGOsForAccount: async (eecsAccount) => {
    return await dispatch(fetchAllEecsGOsForAccount(eecsAccount));
  },
});

export default withRouter(
  withTranslation(NAMESPACES.account)(
    connect(mapStateToProps, mapDispatchToProps)(AccountOverviewPage)
  )
);
